<template>
    <div v-if="itemPreview[this.item.id] == null" class="flex items-center justify-center w-full">
        <label :for="`refund-upload-${item.id}`" class="pt-5 pb-2 flex flex-col items-center justify-center w-full h-1/3 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-camera-fill" viewBox="0 0 16 16">
                <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
                <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"/>
            </svg>
            <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Click to upload</span></p>
        </label>
        <input type="file" accept="image/*" @change="itemPreviewImage" class="form-control-file" :id="`refund-upload-${item.id}`" style="display:none;">
    </div>
    <div v-if="itemPreview[this.item.id]" class="p-2 mt-3 relative">
        <img :src="itemPreview[this.item.id]" class="img-fluid" />

        <div v-if="!showRemovetItemImage" class="bg-white rounded-md border border-gray p-2 absolute bottom-2 right-2 z-10">
            <img src="/images/icons/trash.svg" width="20" height="20" alt="DeleteImage"
                class="cursor-pointer" @click="showRemovetItemImage = true"
            />
        </div>

        <!-- Remove Image Div -->
        <div v-show="showRemovetItemImage" class="z-30 absolute top-8 bg-white text-center rounded-lg border border-gray shadow-lg">
            <h2 class="bg-red-400 text-white px-4 py-2 rounded-t-lg">Delete Current Image</h2>
            <div class="my-6">Are you sure?</div>

            <div class="mt-4 mb-2 w-full">
                <jet-button @click.prevent="removeItemCurrentImage([this.item.id])" class="mr-3">
                    Yes
                </jet-button>

                <jet-tertiary-button @click.prevent="showRemovetItemImage = false;" class="ml-3">
                    No
                </jet-tertiary-button>
            </div>
        </div>
    </div>
</template>

<script>
import JetButton from '@/Jetstream/Button';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetLabel from '@/Jetstream/Label';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import Compressor from 'compressorjs';

export default {
    components: {
        JetButton,
        JetInput,
        JetInputError,
        JetDialogModal,
        JetLabel,
        JetTertiaryButton,
    },

    props: [
        'form',
        'item',
        'itemPreview',
    ],

    data() {
        return {
            showRemovetItemImage: false,
        }
    },

    methods: {
        removeItemCurrentImage (id) {
            delete this.itemPreview[id];
            delete this.form.itemImages[id];
            this.showRemovetItemImage = false;
        },

        itemPreviewImage(event) {
            var inputItem = event.target;
            
            if (inputItem.files) {
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.itemPreview[this.item.id] = e.target.result;
                }

                let file = inputItem.files[0];
                new Compressor(file, {
                    quality: .8,
                    maxWidth: 800,
                    resize: true,

                    success: (result) => {
                        let newFile = new File([result], file.name, { type: file.type, lastModified: new Date().getTime() });

                        this.form.itemImages[this.item.id] = newFile;
                    },

                    error: (error) => {
                        console.log(error);
                    },
                });

                reader.readAsDataURL(inputItem.files[0]);
            }
        },
    },
}
</script>